import React, { useEffect, useState } from "react";
import { Tabs, Spin, Dropdown, message, Select, Modal, Form, Input, DatePicker } from "antd";
import styled from "styled-components";
import { EditOutlined, DownOutlined } from "@ant-design/icons";
import AdvisoryMatter from "../Matter/AdvisoryMatter";
import FinancialSummary from "./Financialsummary";
import ActivityLog from "./Activitylog";
import Transcation from "./Tranasacation";
import BillsModule from "./Billing";
import TimeLog from "./TimeLog";
import ClaimsLog from "./Claim";
import AllTasks from "pages/AllTasks";
import COLORS from "common/Colors";
import { useHistory, useLocation, useParams } from "react-router-dom";
import DocumentTab from "pages/ClientNew/DocumentTab";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import UnapprovedTimesheetModal from "./UnapprovedTimesheetModal";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { useSelector } from "react-redux";
import { getUserInfo, getUserList } from "redux/selectors";
import dayjs from "dayjs";


// ── Styled Components ─────────────────────────────────────────────────────────

const Container = styled.div`
  background: #fff;
  padding:  0;

  .editmatter {
    font-weight: 400;
    font-size: 15px;
    line-height: 100%;
    color: #1a1a1a;
  }
`;

// Row 1: breadcrumb left, actions right — all on one line
const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
`;

const BreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #6b7280;
`;

const Crumb = styled.span`
  cursor: pointer;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  &:hover { color: #111827; }
`;

const BreadcrumbSep = styled.span`
  color: #9ca3af;
  font-size: 14px;
`;

const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
`;

const MoreActionBtn = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 6px 16px;
  border-radius: 8px;
  background: #00685F;
  border: none;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  transition: background 0.15s;
  &:hover { background: #00685F; }

  .arrow {
    font-size: 12px;
    color: #ffffff;
  }
`;

const StyledDropdownMenu = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.13);
  padding: 6px 0;
  min-width: 220px;
  overflow: hidden;
  .ant-dropdown-menu {
    border-radius: 12px;
    box-shadow: none;
    padding: 0;
    background: transparent;
  }
  .ant-dropdown-menu-item {
    font-size: 15px;
    font-weight: 400;
    color: #1a1a1a;
    padding: 12px 20px;
    &:hover { background-color: #f0fdf9; }
  }
`;

// Row 2: title + status badge
const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 4px;
`;

const PageTitle = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #111827;
`;

const TitleDivider = styled.div`
  width: 1px;
  height: 22px;
  background: #d1d5db;
`;

const STATUS_COLOR = {
	"Completed": "#16a34a",
	"Active": "#16a34a",
	"Not Started": "#16a34a",
	"On Hold": "#f59e0b",
	"Cancelled": "#ef4444",
};


const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 15px;
  font-weight: 500;
  color: #111827;

  .status-dot {
    position: relative;
    width: 17px;
    height: 17px;
    border-radius: 50%;
    flex-shrink: 0;
    border: 5px solid ${({ status }) => STATUS_COLOR[status] ?? "#16a34a"};
    background: transparent;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #ffffff;
    }
  }
`;

const StyledTabs = styled(Tabs)`
  margin-top: 16px;
  .ant-tabs-nav { margin: 0; font-weight: 500; color: ${COLORS.TEXT.PRIMARY}; }
  .ant-tabs-tab {
    font-size: 15px;
    &:hover { color: ${COLORS.TEXT.PRIMARY}; }
  }
  .ant-tabs-ink-bar { background: ${COLORS.TAB}; }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 600;
    font-size: 15px;
  }
`;

const FullPageLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  width: 100%;
`;

// ── Component ─────────────────────────────────────────────────────────────────
const AdvisoryMatterHeader = () => {
	const history = useHistory();
	const location = useLocation();
	const { id } = useParams();

	const [matterData, setMatterData] = useState(null);
	const [unapprovedModal, setUnapprovedModal] = useState(false);
	const [closeMatterModal, setCloseMatterModal] = useState(false);
	const [closingMatter, setClosingMatter] = useState(false);
	const [loading, setLoading] = useState(true);
	const [activeTab, setActiveTab] = useState(
    location.state?.returnTab || "1"
);

	const [closeForm] = Form.useForm();
	const userInfo = useSelector(getUserInfo);
	const userList = useSelector(getUserList) || [];
	const matterId = id || location.state?.matterId || location.state?.matterData?.matterId || location.state?.matterData?.matter_id || null;

	useEffect(() => {
		if (location.state?.activeTab === "billing") {
			setActiveTab("6");
		}
	}, [location.state]);

	useEffect(() => {
		if (!matterId) { setLoading(false); return; }

		fetchMatter();
	}, [matterId]);

	const matterTitle = matterData?.information?.jobTitle || matterData?.jobTitle || "Matter Details";

	const displayId = matterData?.matterId || matterId || "";
	const matterStatus = matterData?.matterStatus || "Not Started";

	const handleEdit = (e) => {
		e.stopPropagation();
		if (!matterId) return;
		history.push({
			pathname: `/create-matter/${matterId}`,
			state: {
				editData: {
					...matterData,
					responsiblePersonnel: matterData?.responsiblePersonnel || [],
				},
				editMode: true,
				from: `/matter-details/${matterId}`,        // ← return path
				matterName: matterTitle,
				returnTab: activeTab,  
			},
		});
	};

	const canEditMatter = () => {
		const currentUser = userInfo?.userid;
		const status = matterData?.matterStatus;
		if (status === "Closed") return false;
		if (!matterData || !currentUser) return false;
		const isCreator = matterData.createdBy === currentUser;
		const isLeadAttorney = matterData.leadAttorney === currentUser;
		const isReferringAttorney = matterData.referringAttorney === currentUser;
		return isCreator || isLeadAttorney || isReferringAttorney;
	};

	const isEditable = canEditMatter();

	const fetchMatter = async () => {
		setLoading(true);
		try {
			const resp = await CALL_FEATCH_API(
				`insyts-matter/viewmatter?matterid=${matterId}`,
				"GET"
			);
			const data = resp?.response?.data || resp?.response || resp?.data || resp;
			if (data) setMatterData(data);
		} catch (err) {
			console.error("viewmatter error:", err);
			message.error("Failed to load matter details.");
		} finally {
			setLoading(false);
		}
	};

	const itemsMoreAction = [
		{ key: "1", label: "Financial Summary" },
		{
			key: "2",
			label: (
				<span style={{ opacity: !isEditable ? 0.4 : 1 }}>
					Client Survey
				</span>
			),
			disabled: !isEditable,
		},
		{ key: "3", label: "Unapproved Timesheet" },
		{
			key: "4",
			label: (
				<span style={{ opacity: !isEditable ? 0.4 : 1 }}>
					Add Resource
				</span>
			),
			disabled: !isEditable,
		},

	];

	const tabItems = [
		{ key: "1", label: "Matter Details", children: <AdvisoryMatter matterData={matterData} loading={loading} /> },
		{ key: "2", label: "Financial & Resource", children: <FinancialSummary matterData={matterData} /> },
		{ key: "3", label: "Document", children: <DocumentTab matterData={matterData} matterId={matterId} /> },
		{ key: "4", label: "Activity Log", children: <ActivityLog matterData={matterData} /> },
		{ key: "5", label: "Fund Log", children: <Transcation matterId={matterId} matterData={matterData} /> },
		{ key: "6", label: "Billing", children: <BillsModule matterId={matterId} matterData={matterData} /> },
		{ key: "7", label: "TimeLog", children: <TimeLog matterData={matterData} fetchMatter={fetchMatter} /> },
		{ key: "8", label: "Claims", children: <ClaimsLog matterId={matterId} matterData={matterData} /> },
		{ key: "9", label: "Task", children: <AllTasks matterId={matterId} matterName={matterTitle} /> },
	];

	if (loading) {
		return (
			<FullPageLoader>
				<Spin size="large" tip="Loading matter details..." />
			</FullPageLoader>
		);
	}

	const handleMoreActionClick = ({ key }) => {
		if (key === "1") {
			history.push({
				pathname: `/matter-details/${matterId}/financialSummaryMatter`,
				state: {
					matterData: matterData
				}
			});
		} else if (key === "2") {
			history.push({
				pathname: `/matter-details/${matterId}/clientSurveyMatter`,
				state: { matterData }
			});
		} else if (key === "3") {
			setUnapprovedModal(true);   // ← open modal
		} else if (key === "4") {
			const serializeDate = (value) => {
				if (!value) return null;
				if (typeof value === "string") return value;
				if (typeof value?.format === "function") return value.format("YYYY-MM-DD");
				if (value instanceof Date) return value.toISOString().split("T")[0];
				return null;
			};

			const toPlain = (val) => {
				if (val === null || val === undefined) return val;
				if (typeof val?.format === "function") return serializeDate(val);
				if (val instanceof Date) return val.toISOString().split("T")[0];
				if (Array.isArray(val)) return val.map(toPlain);
				if (typeof val === "object") {
					return Object.fromEntries(
						Object.entries(val).map(([k, v]) => [k, toPlain(v)])
					);
				}
				return val;
			};

			const existingResourceList = (
				matterData?.employeeList || matterData?.resourceList || []
			).map((r) => ({
				userId: r.userId || r.userid || r.employeeId || "",
				name: r.employeeName || r.name || r.fullname || "",
				...toPlain(r),
			}));

			history.push("/create-matter/add-resources", {

				leadAttorneyId: matterData?.leadAttorney || "",
				referringAttorneyId: matterData?.referringAttorney || "",

				planStartDate: serializeDate(
					matterData?.stakeHolder?.planStartDate || matterData?.planStartDate
				),
				planEndDate: serializeDate(
					matterData?.stakeHolder?.planEndDate || matterData?.planEndDate
				),

				resourceList: existingResourceList,

				editMode: true,
				editData: toPlain(matterData),
				matterId,

				formTitle: matterTitle,

				fromMatterDetails: true,
			});
		}
	};
	const isStatusLocked = matterData?.pfaStatus === "Not Approved" ? "Not Approved" :
		matterStatus === "Not Started" || matterStatus === "Not Approved";

	// Build "Closed By" options from Lead Attorney + Referring Attorney
	const closedByOptions = (() => {
		const ids = [
			matterData?.stakeHolder?.leadAttorney || matterData?.leadAttorney,
			matterData?.stakeHolder?.referringAttorney || matterData?.referringAttorney,
		].filter(Boolean);
		return (userList || [])
			.filter((u) => ids.includes(u.userid))
			.map((u) => ({ label: u.fullname, value: u.userid }));
	})();

	const handleStatusChange = (val) => {
		if (val === "Closed") {
			closeForm.setFieldsValue({
				closedOn: dayjs(),
				closedBy: undefined,
				comment: "",
			});
			setCloseMatterModal(true);
		}
	};

	const handleCloseMatter = async () => {
		let values;
		try {
			values = await closeForm.validateFields();
		} catch {
			return;
		}
		setClosingMatter(true);
		try {
			const payload = {
				matterId,
				clientId: matterData?.clientId || "",
				leadAttorney: matterData?.leadAttorney || "",
				referringAttorney: matterData?.referringAttorney || "",
				createdBy: matterData?.createdBy || "",
				matterStatus: "Closed",
				closeDate: values.closedOn ? values.closedOn.format("DD-MM-YYYY") : "",
				closedBy: values.closedBy || "",
				closedComments: values.comment || "",
			};
			let response = await CALL_FEATCH_API("insyts-matter/updatematter", "PATCH", payload);
			if (response?.status === "BAD_REQUEST") {
				message.error(response?.response?.message);
			} else {
				message.success("Matter closed successfully.");
			}
			setCloseMatterModal(false);
			fetchMatter();
		} catch (err) {
			console.error("Close matter error:", err);
			message.error("Failed to close matter.");
		} finally {
			setClosingMatter(false);
		}
	};
	return (
		<Container>

			{/* ── Row 1: breadcrumb ←→ Edit Matter + More Action ── */}
			<TopRow>
				<BreadcrumbWrapper>
					<Crumb onClick={() => history.push("/matter")}>Matter</Crumb>
					<BreadcrumbSep>›</BreadcrumbSep>
					<Crumb>{matterTitle}</Crumb>
				</BreadcrumbWrapper>

				<ActionsRow>
					{/* Edit Matter */}
					{canEditMatter() && (
						<div
							onClick={handleEdit}
							style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}
						>
							<EditOutlined style={{
                                             color: "#00685F",
                                            cursor: "pointer",
                                            background: "#deefee",
                                            padding: "2px",
                                            borderRadius: "4px",
                                            height: "25px",
                                            width: "25px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: 18
                                        }} />
							<span>Edit Matter</span>
						</div>
					)}
					{/* More Action with dropdown arrow */}
					<Dropdown
						menu={{ items: itemsMoreAction, onClick: handleMoreActionClick }}
						trigger={["click"]}
						dropdownRender={(menu) => (
							<StyledDropdownMenu>{menu}</StyledDropdownMenu>
						)}
					>
						<MoreActionBtn>
							More Action
							<DownOutlined className="arrow" />
						</MoreActionBtn>
					</Dropdown>
				</ActionsRow>
			</TopRow>

			{/* ── Row 2: title + status ── */}
			<TitleRow>
				<PageTitle>
					{matterTitle}{displayId ? ` (${displayId})` : ""}
				</PageTitle>
				<TitleDivider />
				<StatusBadge status={matterStatus}>
					<span className="status-dot" />
					{/* {matterStatus} */}
				</StatusBadge>
				<Select
					value={matterData?.pfaStatus === "Not Approved" ? "Not Approved" : matterStatus || "Not Started"}
					style={{
						width: 190,
					}}
					disabled={isStatusLocked}
					onChange={handleStatusChange}
					options={[
						{ label: "Active", value: "Active" },

						// ✅ Only show Closed if user has permission
						...(isEditable
							? [{ label: "Closed", value: "Closed" }]
							: []),
					]}
					labelRender={(props) => (
						<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
							<span
								style={{
									width: "14px",
									height: "14px",
									borderRadius: "50%",
									border: `4px solid ${STATUS_COLOR[props.value] || "#16a34a"}`,
									display: "inline-block",
									flexShrink: 0,
								}}
							/>
							{props.label}
						</div>
					)}
					dropdownStyle={{
						borderRadius: "10px",
					}}
					optionRender={(option) => (
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "8px",
							}}
						>
							<span
								style={{
									width: "14px",
									height: "14px",
									borderRadius: "50%",
									border: `4px solid ${STATUS_COLOR[option.data.value] || "#16a34a"
										}`,
									display: "inline-block",
									position: "relative",
								}}
							/>
							{option.data.label}
						</div>
					)}
				/>
			</TitleRow>

			{/* ── Tabs ── */}
			<StyledTabs activeKey={activeTab}
				onChange={(key) => setActiveTab(key)}
				items={tabItems} />

			<UnapprovedTimesheetModal
				matterId={matterId}
				visible={unapprovedModal}
				onClose={() => setUnapprovedModal(false)}
			/>

			{/* ── Close Matter Modal ── */}
			<Modal
				title="Close Matter"
				open={closeMatterModal}
				onCancel={() => setCloseMatterModal(false)}
				footer={null}
				width={560}
				destroyOnClose
			>
				<p style={{ marginBottom: 20, fontSize: 14, color: "#333" }}>
					Are you sure you want to close this matter?
				</p>
				<Form form={closeForm} layout="vertical">
					<Form.Item
						name="closedOn"
						label={<span>Closed On</span>}
					>
						<DatePicker
							style={{ width: "100%" }}
							format="DD-MM-YYYY"
							placeholder="DD-MM-YYYY"
							disabled
						/>
					</Form.Item>

					<Form.Item
						name="closedBy"
						label={<span>Closed By</span>}
						rules={[{ required: true, message: "Closed By is required" }]}
					>
						<Select
							placeholder="Select"
							showSearch
							optionFilterProp="label"
							options={closedByOptions}
							style={{ width: "100%" }}
						/>
					</Form.Item>

					<Form.Item
						name="comment"
						label={<span>Comment</span>}
						rules={[{ required: true, message: "Comment is required" }]}
					>
						<Input.TextArea
							rows={3}
							placeholder="Enter comment"
						/>
					</Form.Item>
				</Form>

				<div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 8 }}>
					<button
						onClick={() => setCloseMatterModal(false)}
						style={{
							padding: "6px 24px",
							border: "1px solid #d9d9d9",
							borderRadius: 4,
							background: "#fff",
							cursor: "pointer",
							fontSize: 14,
						}}
					>
						No
					</button>
					<button
						onClick={handleCloseMatter}
						disabled={closingMatter}
						style={{
							padding: "6px 24px",
							border: "none",
							borderRadius: 4,
							background: "#c2fae5",
							cursor: closingMatter ? "not-allowed" : "pointer",
							fontWeight: 600,
							fontSize: 14,
							opacity: closingMatter ? 0.7 : 1,
						}}
					>
						{closingMatter ? "Closing..." : "Yes"}
					</button>
				</div>
			</Modal>

		</Container>
	);
};

export default AdvisoryMatterHeader;